import { Dispatch, Key, SetStateAction, useState } from 'react'

function useSelectableList<T extends { id: Key }>(
  onAdd?: (element: T) => void,
  onRemove?: (element: T) => void,
): [T[], (element: T, selected: boolean) => void, Dispatch<SetStateAction<T[]>>] {
  const [selectedElements, setSelectedElements] = useState<T[]>([])

  const onSelectElement = (element: T, selected: boolean) => {
    if (selected) {
      setSelectedElements((se) => [...se, element])
      if (onAdd) onAdd(element)
    } else {
      setSelectedElements((se) => se.filter((s) => s.id !== element.id))
      if (onRemove) onRemove(element)
    }
  }

  return [selectedElements, onSelectElement, setSelectedElements]
}

export default useSelectableList
